var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, Columns, Icon, IconButton, Text, } from '@dixa/lib-shared-habla';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMount, useUnmount } from 'react-use';
import { statisticsApi } from 'apis/statistics';
import { websocketActions } from 'app/middleware/websocket/actions/websocket';
import { pubSub } from 'utils/pubSub';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppPathParams } from 'utils/url/useAppPathParams';
import { TvDashboardMetrics } from './components/metrics/tvDashboardMetrics';
import styles from './tvDashboard.view.module.scss';
export const TvDashboardView = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { queueId } = useAppPathParams('/tv/dashboard/:queueId');
    const { queue, isLoading } = statisticsApi.useReadDashboardQueuesByIdQuery({ ids: [queueId] }, {
        // Automatically refetch the dashboard data via an HTTP request every hour to ensure the
        // access/refresh tokens are refreshed and the TV dashboard remains logged in indefinitely.
        pollingInterval: 1000 * 60 * 60,
        selectFromResult: (_a) => {
            var { data } = _a, rest = __rest(_a, ["data"]);
            return (Object.assign(Object.assign({}, rest), { queue: data === null || data === void 0 ? void 0 : data.data.dashboard_entries[0] }));
        },
    });
    useMount(() => {
        dispatch(websocketActions.request({
            type: 'connection:subscribe',
            params: {
                type: 'queue_dashboard',
            },
        }));
    });
    useUnmount(() => {
        dispatch(websocketActions.request({
            type: 'connection:unsubscribe',
            params: {
                type: 'queue_dashboard',
            },
        }));
    });
    useEffect(() => {
        const unsubscribe = pubSub.subscribe('dashboardQueueChanged', handleDashboardQueueChanged);
        return () => unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleDashboardQueueChanged = (payload) => {
        const updatedQueue = payload.params.dashboard.dashboard_entries.find((queue) => queue.queue_id === queueId);
        if (updatedQueue) {
            dispatch(statisticsApi.util.updateQueryData('readDashboardQueuesById', {
                ids: [queueId],
            }, (draft) => {
                const mutableData = draft.data;
                mutableData.dashboard_entries = [updatedQueue];
            }));
        }
    };
    return (_jsx(Columns, { children: _jsxs(Column, Object.assign({ className: styles.root }, { children: [_jsxs(Column.Row, Object.assign({ slottable: true, className: styles.header }, { children: [_jsx(Column.Slot, Object.assign({ placement: "start" }, { children: _jsx(IconButton, { icon: "arrow-left", variant: "tertiary", onClick: () => navigate(-1) }) })), _jsx(Column.Slot, Object.assign({ placement: "center" }, { children: _jsx(Icon, { name: "dixa", size: 24, color: "white" }) })), _jsx(Column.Slot, Object.assign({ placement: "end" }, { children: _jsx(Text.Heading, Object.assign({ variant: "heading-2", color: "tertiary" }, { children: queue === null || queue === void 0 ? void 0 : queue.queue.name })) }))] })), _jsx(Column.Row, Object.assign({ scrollable: true, noVerticalPadding: true, noHorizontalPadding: true, className: styles.main }, { children: _jsx(TvDashboardMetrics, { queue: queue, isLoading: isLoading }) }))] })) }));
};
